import {
    Box,
    Button,
    Flex,
    Icon,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Switch,
    Text,
} from '@chakra-ui/react'
import React, { useEffect, useMemo, useState } from 'react'
import { RiLogoutBoxRLine, RiUserFill } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { logoutUserAction } from '../../../modules/auth/Actions'
import { getAllSubjectsRequest, toggleSignupRequest } from '../../../modules/admin-modules/subjects/Actions'

const ADMIN_ROLES = ['Admin', 'Super Admin', 'Teacher']

const LogoutMenu = () => {
    const dispatch = useDispatch()
    const userData = useSelector((state) => state.user.userData)
    const subjects = useSelector((state) => state.subjects.subjects)
    const subjectsLoading = useSelector((state) => state.subjects.isLoading)
    const isAdmin = userData?.role?.some((role) => ADMIN_ROLES.includes(role?.name))
    const isSuperAdmin = userData?.role?.[0]?.name === 'Super Admin'
    const [selectedSubjectId, setSelectedSubjectId] = useState('')

    useEffect(() => {
        if (isAdmin) {
            dispatch(getAllSubjectsRequest())
        }
    }, [dispatch, isAdmin])

    useEffect(() => {
        if (userData?.subject?.id) {
            setSelectedSubjectId(userData.subject.id)
        } else if (isSuperAdmin && subjects?.length) {
            setSelectedSubjectId((current) => current || subjects[0].id)
        }
    }, [userData?.subject?.id, isSuperAdmin, subjects])

    const activeSubject = useMemo(() => {
        if (!selectedSubjectId || !subjects?.length) return null
        return subjects.find(
            (subject) => String(subject.id) === String(selectedSubjectId)
        )
    }, [selectedSubjectId, subjects])

    const subjectsOptions = subjects?.map((subject) => ({
        value: subject.id,
        label: subject.name,
    }))

    const colourStyles = {
        control: (styles) => ({
            ...styles,
            width: '100%',
            minHeight: '32px',
            background: 'white',
            color: '#690000',
            borderRadius: '8px',
        }),
        option: (styles) => ({ ...styles, color: '#690000' }),
    }

    return (
        <Menu closeOnSelect={false}>
            <MenuButton
                bg='transparent'
                borderRadius='26px'
                as={Button}
                p='0'
                _hover={{ bg: 'transparent' }}
                _focus={{ outline: 'none', bg: 'transparent' }}
                _active={{ outline: 'none', bg: 'transparent' }}>
                <Flex
                    borderRadius='16px'
                    border='1px solid'
                    borderColor='main_1'
                    w='52px'
                    h='42px'
                    bg='white'
                    alignItems='flex-end'
                    justifyContent='center'>
                    <Icon as={RiUserFill} color='main_1' fontSize='30px' />

                </Flex>
            </MenuButton>
            <MenuList minW="240px">
                {isAdmin && selectedSubjectId && (
                    <>
                        {isSuperAdmin && (
                            <MenuItem closeOnSelect={false} py={3}>
                                <Box w="100%">
                                    <Text mb={2} fontSize="sm" fontWeight="600">
                                        المادة
                                    </Text>
                                    <Select
                                        options={subjectsOptions}
                                        value={
                                            subjectsOptions?.find(
                                                (option) =>
                                                    String(option.value) === String(selectedSubjectId)
                                            ) || null
                                        }
                                        onChange={(data) => setSelectedSubjectId(data?.value || '')}
                                        styles={colourStyles}
                                        placeholder="Select Subject"
                                    />
                                </Box>
                            </MenuItem>
                        )}
                        <MenuItem closeOnSelect={false}>
                            <Flex align="center" justify="space-between" w="100%">
                                <Text mx="5px">Signup</Text>
                                <Switch
                                    isChecked={activeSubject?.signup == 1}
                                    isDisabled={subjectsLoading}
                                    onChange={() => dispatch(toggleSignupRequest(selectedSubjectId))}
                                />
                            </Flex>
                        </MenuItem>
                    </>
                )}

                <MenuItem p="7px" mt="10px" onClick={() => dispatch(logoutUserAction())}>
                    <Flex>
                        <Icon as={RiLogoutBoxRLine} fontSize="20px" />
                        <Text mx="5px" >
                            تسجيل خروج
                        </Text>
                    </Flex>
                </MenuItem>
            </MenuList>
        </Menu >
    )
}

export default LogoutMenu
